var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M3 18H21V16H3V18ZM3 13H21V11H3V13ZM3 6V8H21V6H3Z","fill":"white"}})])}
var staticRenderFns = []

export { render, staticRenderFns }